import { get, post } from "./base"

export default {
    addToCart: (data) => post(`${window.apiUrl}Cart/add-to-cart`, data, true),
    cartDetails: () => get(`${window.apiUrl}Cart/cart-details`, {}, true),
    promoCodeCart: (code) => {
        return post(`${window.apiUrl}Cart/apply-promocode-cart?promocode=${code}`, {}, true)
    },
    removeCart: (cartId, orderId) =>post(`${window.apiUrl}Cart/remove-from-cart?cartId=${cartId}&programId=${orderId}`, {}, true)
}